<template>
  <div class="module">
    <div class="module__title"></div>
    <div class="module__content">
      <div class="swiper-box">
        <div class="swiper" id="characterSwiper">
          <div class="swiper-wrapper">
            <div
              v-for="(item, key) in characterData"
              :key="key"
              class="swiper-slide swiper-no-swiping"
            >
              <img :src="item.img" />
            </div>
          </div>
          <div class="swiper-pagination">
            <div
              v-for="(item, key) in characterData"
              :key="key"
              class="swiper-pagination__btn"
              :class="{ active: swiper.activeIndex == key }"
            >
              <img :src="swiper.activeIndex == key ? item.avatar_active : item.avatar_inactive" />
            </div>
          </div>
        </div>
        <div ref="doorBox" class="door-box">
          <div class="door left"></div>
          <div class="door right"></div>
        </div>
        <div ref="cloudBox" class="cloud-box">
          <div class="cloud cloud-1"></div>
          <div class="cloud cloud-2"></div>
          <div class="cloud cloud-3"></div>
        </div>
      </div>
      <div class="scroll">
        <div class="scroll__content" ref="textBox">
          <!-- <div class="text-box" ref="textBox"> -->
            <div class="text">{{ description }}</div>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import characterMixins from '@/mixins/home/characterMixins.js'

export default {
  name: 'MobileHomeCharacter',
  mixins: [characterMixins],
}
</script>

<style lang="scss" scoped>
.module {
  height: 196.133333vw;

  &__title {
    background-position: center -69.6vw;
  }

  &__content {
    position: relative;
    margin-top: 4.533333vw;
    width: 100%;
    height: 90vw;
  }
}

.scroll {
  position: absolute;
  top: 76vw;
  left: 50%;
  transform: translateX(-50%);
  width: 58.4vw;
  height: 40vw;
  background: url('~@/assets/img/mobile/scroll_bg.png') no-repeat;
  background-size: 100%;

  &__content {
    position: absolute;
    top: 21.833333vw;
    padding: 0 7.2vw;
    width: 100%;
    height: 13.5vw;
    overflow: hidden;
    
    .text {
      text-indent: 5.6vw;
      text-align: justify;
      font-size: 2.666666vw;
      font-family: Noto Serif SC;
      font-weight: bold;
      color: #441f0e;
      letter-spacing: 0.106666vw;
    }

    &::after {
      content: '';
      display: inline-block;
      position: absolute;
      bottom: 0;
      width: calc(100% - 14.4vw);
      height: 1.333333vw;
      background: linear-gradient(180deg, transparent 20%, #edd9b5 90%);
    }
  }
}

.swiper-box {
  position: absolute;
  z-index: 1;
  left: 50%;
  transform: translateX(-50%);
  width: 90vw;
  height: 90vw;
  background: url('~@/assets/img/common/character_bg.png') no-repeat;
  background-size: 100%;
}

.swiper {
  overflow: visible;

  ::v-deep .swiper-slide {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90vw;
    height: 90vw;

    img {
      opacity: 0;
      height: 72vw;
    }
  }
  ::v-deep .swiper-slide-active {
    img {
      animation: .5s characterfadeIn .5s linear forwards;
    }
  }

  ::v-deep .swiper-pagination {
    display: flex;
    justify-content: center;
    position: absolute;
    top: 120.266666vw;
    // width: 18.4vw;
    height: 17.2vw;

    .swiper-pagination__btn {
      margin: 0 1.6vw;
      width: 18.4vw;
      height: 17.2vw;

      &.active {
        transform: scale(1.1);
      }

      &.active::after {
        content: '';
        position: absolute;
        left: .8vw;
        bottom: 0;
        width: 20vw;
        height: 6.666363vw;
        background: url('~@/assets/img/common/avatar_active.png') no-repeat;
        background-size: 100%;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.door-box {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
  display: block;
  overflow: hidden;
  width: 78vw;
  height: 78vw;
  border-radius: 50%;

  .door {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 42vw;
    height: 79vw;
  }

  .left {
    left: -3vw;
    background: url('~@/assets/img/mobile/door_l.png') no-repeat;
    background-size: 100% 100%;
  }

  .right {
    right: -3vw;
    background: url('~@/assets/img/mobile/door_r.png') no-repeat;
    background-size: 100% 100%;
  }

  &.animation {
    .left {
      animation: .8s openLeftDoor linear forwards;
    }

    .right {
      animation: .8s openRightDoor linear forwards;
    }
  }
}

@keyframes openLeftDoor {
  0% {
    left: -3vw;
  }
  100% {
    left: -30vw;
  }
}

@keyframes openRightDoor {
  0% {
    right: -3vw;
  }
  100% {
    right: -30vw;
  }
}

.cloud-box {
  position: absolute;
  left: 50%;
  bottom: -1vw;
  transform: translateX(-50%);
  z-index: 1;
  width: 98.666666vw;
  height: 30.8vw;

  .cloud {
    position: absolute;
    opacity: 0;
  }

  .cloud-1 {
    right: 0;
    bottom: 1.333333vw;
    width: 62.4vw;
    height: 34.666666vw;
    background: url('~@/assets/img/common/cloud1.png') no-repeat;
    background-size: 100% 100%;
  }

  .cloud-2 {
    left: 3.066666vw;
    bottom: 6.8vw;
    width: 60.533333vw;
    height: 24vw;
    background: url('~@/assets/img/common/cloud2.png') no-repeat;
    background-size: 100% 100%;
  }

  .cloud-3 {
    left: 0;
    bottom: 0;
    width: 65.733333vw;
    height: 25.733333vw;
    background: url('~@/assets/img/common/cloud3.png') no-repeat;
    background-size: 100% 100%;
  }

  &.animation {
    .cloud-1 {
      animation: 1s cloud1 .2s linear forwards;
    }
    .cloud-2 {
      animation: .7s cloud2 .4s linear forwards;
    }
    .cloud-3 {
      animation: .6s cloud3 .6s linear forwards;
    }
  }
}

@keyframes cloud1 {
  0% {
    right: 13.333333vw;
    bottom: 1.333333vw;
    opacity: 0;
    transform: scale(.8);
  }
  100% {
    right: 0;
    bottom: 1.333333vw;
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes cloud2 {
  0% {
    left: 16.666666vw;
    bottom: 4.8vw;
    opacity: 0;
    transform: scale(.8);
  }
  100% {
    left: 3.066666vw;
    bottom: 6.8vw;
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes cloud3 {
  0% {
    left: 13.333333vw;
    bottom: 0;
    opacity: 0;
    transform: scale(.8);
  }
  100% {
    left: 0;
    bottom: 0;
    opacity: 1;
    transform: scale(1);
  }
}
</style>
